/**
 * Chaves hierárquicas do cache TanStack Query do portal — invalidação ampla
 * (`blogKeys.courses.all`) ou estreita (`blogKeys.purchases.detail(id)`), nunca
 * a mesma entrada relida sob outro filtro.
 */
export const blogKeys = {
  courses: {
    all: ['blog-courses'] as const,
    detail: (slug: string) => ['blog-courses', 'detail', slug] as const,
    lessonContent: (slug: string, lessonId: string) =>
      ['blog-courses', 'lesson', slug, lessonId] as const,
    /** Prefixo de todas as lições de um curso — o estorno destrava o conjunto. */
    lessonContentAll: (slug: string) => ['blog-courses', 'lesson', slug] as const,
  },

  entitlements: ['blog-entitlements'] as const,

  purchases: {
    all: ['blog-purchases'] as const,
    detail: (id: string) => ['blog-purchases', 'detail', id] as const,
  },

  /** A configuração pública do site (topbar, rodapé, equipe). */
  site: ['blog-site'] as const,
  tracks: ['blog-tracks'] as const,

  profile: ['blog-profile'] as const,
  history: ['blog-history'] as const,
  resources: ['blog-resources'] as const,
  community: ['blog-community'] as const,
  notifications: ['blog-notifications'] as const,

  /** O que o /admin edita; as escritas invalidam também {@link blogKeys.site}. */
  adminSite: ['blog-admin-site'] as const,
  adminNotifications: ['blog-admin-notifications'] as const,
};
